/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Partnerrelations1Inputs */

const de__field_partnerrelations1 = /** @type {(inputs: _Field_Partnerrelations1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kooperationspartner beteiligt`)
};

/**

* @param {_Field_Partnerrelations1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_partnerrelations1 = /** @type {((inputs?: _Field_Partnerrelations1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Partnerrelations1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_partnerrelations1(inputs)
});
export { _field_partnerrelations1 as "_field_partnerRelations" }